import { Header, Icon } from '@iqueue/ui-kit'
import cn from 'classnames'
import { t } from '../../../hooks/useTranslate'
import HourlyProductionChart from './HourlyProductionChart'
import ProductionDiffLine from '../ProductionDiffLine'
import NodesTrafficLight from '../NodesTrafficLight'
import { UNIT_VOLUME } from '../Measurement'

export default function FactoryCard({
  summary: {
    hourlyValue = 0,
    pastHourValue = 0,
    dailyValue = 0,
    pastDayValue = 0,
    monthlyValue = 0,
    pastMonthValue = 0,
    yearlyValue = 0,
    pastYearValue = 0,
  } = {},
  type,
  nodes = {},
  hourlyChart = [],
  name = 'Production Authority',
  className,
  onClick,
}) {
  return <div
    className={ cn('gas-and-oil-card interactive', className) }
    onClick={ onClick }
  >
    <Header
      title={ <>
        <b><Icon filled style={ { marginRight: '0.8rem' } }>factory</Icon></b>
        <span>{ name }</span>
      </> }
      subtitle={ t(`type.node.${ type }`) }
      extra={ <NodesTrafficLight nodes={ nodes }/> }
    />

    <div className={ 'content' }>
      <HourlyProductionChart
        hourlyData={ hourlyChart }
        currentHourValue={ hourlyValue }
        pastHourValue={ pastHourValue }
        unit={ UNIT_VOLUME }
      />

      <ProductionDiffLine
        title={ t('productionLabels.dailyProduction') }
        current={ dailyValue }
        past={ pastDayValue }
        unit={ UNIT_VOLUME }
      />

      <ProductionDiffLine
        title={ t('productionLabels.monthlyProduction') }
        current={ monthlyValue }
        past={ pastMonthValue }
        unit={ UNIT_VOLUME }
      />

      <ProductionDiffLine
        title={ t('productionLabels.yearlyProduction') }
        current={ yearlyValue }
        past={ pastYearValue }
        unit={ UNIT_VOLUME }
      />
    </div>
  </div>
}
